import React from 'react';
import './Mentor.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'


const Mentor = (props) => {
    const { name, Age, Salary, Country, Expriance, img } = props.mentor || {}
    const element = <FontAwesomeIcon icon={faShoppingCart} />

    return (
        <div className="mentor">
            <div className="mentor-image">
                <img src={img} alt="" />
            </div>
            <div className="mentor-details">
                <strong><h1>{name}</h1></strong>
                <p><strong>Age :</strong> {Age}</p>
                <p><strong>Salary :</strong> {Salary}</p>
                <p><strong>Country :</strong> {Country}</p>
                <p><strong>Expriance: {Expriance}</strong></p>

                <button onClick={() => props.handler(props.mentor)}>{element}  Add Member</button>
            </div>
        </div>
    );
};

export default Mentor;